import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'productVariationPage',
  setup(__props) {

const productVariationComp = defineAsyncComponent(() => import('@/components/managementPages/productVariationPage/productVariationComp.vue'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(productVariationComp)))
}
}

})